export const MIN_COMPARE_IMAGES = 2;
export const MAX_COMPARE_IMAGES = 4;

export function canCompareImages(selectedCount: number): boolean {
    return selectedCount >= MIN_COMPARE_IMAGES && selectedCount <= MAX_COMPARE_IMAGES;
}
